import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledLabel = styled.label`
  width: 100%;
  height: 200px;
  color: ${theme.palette.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: solid 1px transparent;
  border-radius: 5px;
  box-shadow: 0 0 2px ${theme.palette.primary.main};
  cursor: ${(props) =>
    props.isWeb || props.refillable ? "pointer" : "default"};
  overflow: hidden;
  direction: ltr;
`;

export const DeleteDiv = styled.div`
  width: 25px;
  height: 25px;
  background-color: white;
  color: ${theme.palette.primary.main};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0px;
  left: 0;
  border-radius: 2px;
  border-top-right-radius: 10px;
  box-shadow: 0 0 5px gray;
  cursor: pointer;
  &:hover {
    box-shadow: 0 0 8px gray;
  }
`;
